<template>
  <nav class="nav-bar">
    <!-- class="maxW" -->
    <main>
      <div style="display: flex;">
        <div class="nav_box" style="justify-content: flex-end;">
          <template v-for="(item, index) in navList">
            <div class="item_i" style=" margin-left: 3vw;" v-if="index < 5" :class="{ 'active': activeIndex == index }"
              :key="item.url" @click="goToPath(item.url, index, item)">{{ item.name }}</div>
          </template>
        </div>
        <div style="width: 15%;height: 4rem;"></div>
        <div class="nav_box">
          <template v-for="(item, index) in navList">
            <div class="item_i" style=" margin-right: 3vw;" v-if="index >= 5"
              :class="{ 'active': activeIndex == index }" :key="item.url" @click="goToPath(item.url, index, item)">{{
                item.name }}</div>
          </template>
        </div>
      </div>
      <div class="banner_v2">
        <img src="../../../assets/images/banner_v2.png" />
      </div>
    </main>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      navList: [],
    };
  },
  computed: mapState(['activeIndex']),
  watch: {

    $route: {
      handler(to, from) {

        if (to?.name) {
          let name = to.meta.activeName
          const index = this.navList.findIndex(item => item.url.includes(name))
          index > -1 && this.$store.commit('SET_ACTIVEINDEX', index)
          // this.$store.commit("Change_Cate", 0);
        }

      },
      deep: true, immediate: true
    },
  },

  created() {
    this.getHeadMenu();
  },

  methods: {
    goToPath(path, index, row) {
      // 考试中心
      if (row.id === 4) {
        this.getQingCasFrontUrl()
        return
      }
      this.$store.commit("Change_Cate", 0);
      this.$store.commit('SET_ACTIVEINDEX', index)
      this.$router.push(path);
      window.sessionStorage.setItem('activeIndex', index)

    },
    // 获取单点登录跳转地址
    getQingCasFrontUrl() {
      let success = (res) => {
        if (res.code === 200) {
          window.location.href = res.data;
        } else {
          this.$message.error(res.msg);
        }
      };
      this.$ajax.get("api/assignment/getQingCasFrontUrl", {
        params: { number: this.$store.state.userInfo.number },
        func: {
          success: success,
        },
      });
    },
    // 获取页面头部菜单栏的数据
    getHeadMenu() {
      let success = (res) => {

        let dataArr = res.data;
        this.activeArr = dataArr.map((item) => item.url);
        if (res.data[0].url == "/") {
          res.data[0].url = "/homeindex";
        }
        this.navList = res.data;
      };
      this.$ajax.get("api/system/get_home_menu_cansee", {
        params: {},
        func: {
          success: success,
        },
      });
    },
  },
};
</script>

<style scoped lang='scss'>
.nav-bar {
  background-color: #fff;
  user-select: none;
  height: 50px;
  line-height: 50px;

  main {

    .nav_box {
      width: 43%;
      height: 4rem;
      display: flex;
    }

    .item_i {
      color: #333;
      font-size: 1.4rem;
      font-weight: 800;
      // letter-spacing: 0.2rem;

      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }

    .active {
      color: #e62125;

      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }

      &:after {
        content: "";
        display: block;
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 0.5rem;
        background-color: #e62125;
        position: relative;
        top: -0.8rem;
        left: calc(50% - 0.25rem);
      }
    }
  }

  .banner_v2 {
    position: relative;
    width: 100%;
    min-height: 20px;
    background-color: #fff;
    z-index: 0;

    &::after {
      z-index: 98;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 20px;
      display: block;
      background: linear-gradient(-45deg,
          transparent 33.33%,
          #fff 33.33%,
          #fff 66.666%,
          transparent 66.666%),
        linear-gradient(45deg,
          transparent 33.33%,
          #fff 33.33%,
          #fff 66.666%,
          transparent 66.666%);
      background-size: 12px 60px;
      transform: rotate(180deg);
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
